import "../LootboxBanner/LootboxBanner.scss";
import "./GiveawayBanner.scss";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import {PATHS_API} from "../../../../../../../enum";
import {PATHS} from "../../../../../../routers/utils/Paths.links";
import {useI18n} from "../../../../../../i18n/I18nProvider";
import FloatingPrizes from "../../../../../../shared/FloatingPrizes/FloatingPrizes";

const pad = (n: number) => String(n).padStart(2, "0");

// Скільки лишилось до підсумків: «2д 05:13:42», оновлюється щосекунди
const useTimeLeft = (endsAt: string | null) => {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        if (!endsAt) return;
        const timer = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(timer);
    }, [endsAt]);
    if (!endsAt) return null;
    const seconds = Math.max(0, Math.floor((new Date(endsAt).getTime() - now) / 1000));
    return {
        done: seconds === 0,
        days: Math.floor(seconds / 86400),
        clock: `${pad(Math.floor(seconds / 3600) % 24)}:${pad(Math.floor(seconds / 60) % 60)}:${pad(seconds % 60)}`,
    };
};

// Банер розіграшів у сітці товарів: та сама розмітка, що й у банера ящика, але синій, а в ньому літають призи поточних розіграшів
const GiveawayBanner = () => {
    const { t } = useI18n();
    const [prizes, setPrizes] = useState<{ _id: string, imageUrl: string }[]>([]);
    const [endsAt, setEndsAt] = useState<string | null>(null);
    const left = useTimeLeft(endsAt);

    // призи активних розіграшів; найдорожчий іде першим — він більший і по центру
    useEffect(() => {
        axios.get(PATHS_API.GIVEAWAYS)
            .then(({ data }) => {
                // усі розіграші підсумовуються одночасно, тож беремо найближчий час
                const ends = (data.active ?? []).map((g: any) => g.endsAt).filter(Boolean).sort()[0];
                setEndsAt(ends ?? null);
                setPrizes(
                (data.active ?? [])
                    .filter((g: any) => g.prize?.imageUrl)
                    .sort((a: any, b: any) => (b.prize.price ?? 0) - (a.prize.price ?? 0))
                    .slice(0, 3)
                    .map((g: any) => ({ _id: g._id, imageUrl: g.prize.imageUrl }))
                );
            })
            .catch(() => setPrizes([]));
    }, []);
    return (
        <Link to={PATHS.GIVEAWAYS} className="lb-banner gwb-banner" aria-label={t("giveaways.title")}>
            <div className="lb-rays" aria-hidden="true" />
            <div className="lb-sparks" aria-hidden="true">
                { Array.from({ length: 8 }, (_, i) => <span key={i} style={{ "--d": i } as React.CSSProperties} />) }
            </div>

            <div className="lb-text">
                <h4 className="lb-title">{t("giveaways.title")}</h4>
                { left &&
                    <span className="gwb-timer" role="timer">
                        { left.done
                            ? t("giveaways.drawing")
                            : <>{t("banner.gwEnds")} <b>{left.days > 0 && `${left.days}${t("giveaways.days")} `}{left.clock}</b></> }
                    </span>
                }
                <span className="lb-cta">{t("banner.gwCta")} <span aria-hidden="true">→</span></span>
            </div>

            <FloatingPrizes className="lb-art gwb-art" images={prizes.map((p) => p.imageUrl)} />
        </Link>
    );
};

export default GiveawayBanner;
